import { Component } from '@angular/core';
import { TabPage } from '../../models/TabPage.model';
import { DataStoreService } from '../../core/services/data-store/data-store.service';

// TODO MK-REF
@Component({
  selector: 'baf-home',
  templateUrl: './home.component.html'
})
export class HomeComponent {
  tabs: TabPage[] = [
    {
      title: '',
      caption: '',
      type: 1
    }
  ];

  constructor(storeService: DataStoreService) {
    storeService.getCurrentView().subscribe(text => {
      this.tabs[0].title = storeService.currentViewName;
      this.tabs[0].caption = storeService.currentViewName;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts